import React from 'react';

export default function TermsOfUse() {
  return (
    <div className="terms-container">
      <h1>Terms of Use</h1>
      <p>Last updated: 12/04/2024</p>
      
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using Last Layer Trainer, you accept and agree to be bound by these Terms of Use.</p>
      </section>

      <section>
        <h2>2. Usage Rights</h2>
        <p>Last Layer Trainer is provided for personal use. Users may:</p>
        <ul>
          <li>Use the application for personal practice and training</li>
          <li>Create and maintain a personal account</li>
          <li>Track personal progress and statistics</li>
        </ul>
      </section>

      <section>
        <h2>3. Restrictions</h2>
        <p>Users may not:</p>
        <ul>
          <li>Copy, modify, or distribute the application</li>
          <li>Reverse engineer or attempt to extract the source code</li>
          <li>Use the application for commercial training without explicit permission</li>
          <li>Share account credentials with others</li>
        </ul>
      </section>

      <section>
        <h2>4. Future Updates</h2>
        <p>Last Layer Trainer may introduce new features or services in the future. Users will be notified of any significant changes to these terms.</p>
      </section>

      <section>
        <h2>5. Contact</h2>
        <p>For any questions about these Terms, please contact Nick Best at lastlayercubing@gmail.com.</p>
      </section>

      <section>
        <h2>6. Copyright</h2>
        <p>© {new Date().getFullYear()} Last Layer Trainer. All Rights Reserved.</p>
      </section>
    </div>
  );
} 